<!--
    套餐列表
    jay 2020-01-07
 -->
<template>
  <div class="combo">
    <p v-if="!comboList.length && getListFlag" class="no-operator">
      {{ $t("recharge.operatorNotSupport") }}
    </p>
    <template v-if="comboList.length && getListFlag">
      <div class="combo-title">
        <a
          :class="{ active: comboTitle == index }"
          v-for="(item, index) in comboList"
          :key="index"
          @click="chooseDay(index)"
        >
          {{ item.day }}{{ $t("common.days1") }}
        </a>
      </div>
      <ul>
        <li
          :class="{ active: comboIndex == index }"
          v-for="(item, index) in comboList[comboTitle].list"
          :key="index"
          @click="chooseCombo(item)"
        >
          <p>{{ item.content }}</p>
          <span class="text-orange">{{ item.amount }}P</span>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
export default {
  props: ["operatorId"],
  components: {},
  data() {
    return {
      comboTitle: 0,
      comboIndex: -1,
      comboList: [],
      getListFlag: false
    };
  },
  created() {
    this.getCallsDataDenomination();
  },
  mounted() {},
  computed: {},
  methods: {
    chooseDay(index) {
      // this.$emit('update:comboTitle', index);
      this.comboTitle = index;
    },
    chooseCombo(data) {
      //选择套餐
      let vm = this;
      vm.$emit("getComboInfo", data);
    },
    getCallsDataDenomination() {
      //流量充值面板
      let vm = this;
      let params = {};
      params.operator_id = vm.operatorId;
      vm.getListFlag = false;
      vm.$post("/app/recharge/callsDataDenomination", params, {
        loading: true
      }).then(res => {
        console.log("callsDataDenomination", res);
        vm.getListFlag = true;
        vm.comboList = res.denomination;
      });
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.combo {
  margin-top: 30px;
  .no-operator {
    text-align: center;
    font-size: 14px;
  }
  .combo-title {
    display: flex;
    align-items: center;

    a {
      color: #333333;
      font-size: 15px;
      min-width: 62px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;

      &.active {
        background: #2042ab;
        color: #fff;
      }
    }
  }

  ul {
    margin-top: 12px;
    li {
      min-height: 47px;
      padding: 10px;
      border-bottom: 1px solid #e4e4e4;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;

      p {
        font-size: 14px;
        color: #4a4a4a;
        font-weight: 400;
        max-width: 700px;
      }

      span {
        font-size: 16px;
        color: #fe7800;
        font-weight: 600;
      }

      &.active {
        p,
        span {
          color: #2042ab;
        }
      }
    }
  }
}
</style>
